import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "menu-body"
};
var _hoisted_2 = {
  class: "sidebar-item"
};
var _hoisted_3 = {
  class: "sidebar-name van-multi-ellipsis--l2"
};
var _hoisted_4 = {
  class: "bottom_right_outer_border"
};
var _hoisted_5 = {
  class: "top_right_outer_border"
};
var _hoisted_6 = {
  class: "list-container"
};
var _hoisted_7 = {
  class: "content-list"
};
var _hoisted_8 = {
  class: "title"
};
import { watch, nextTick, computed, ref, onActivated, onDeactivated } from "vue";
import { useScrollMenu } from "@/hooks/useScrollMenu";
import { useShopStoreWithOut } from "@/store/shopStore";
import MenuDish from "./MenuDish.vue";
import DishDetail from "./DishDetail.vue";
import { DISH_STATUS } from "@/constant/dishes";
import { useEventBus } from "@vueuse/core";
import { SHOP_CHANGE_EVENT } from "@/constant/eventKey";
import PoweredBy from "../PoweredBy.vue";
import Image from "../base/Image.vue";
import { showToast } from "@/utils/toastUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'MenuBody',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var bus = useEventBus(SHOP_CHANGE_EVENT);
    var _useScrollMenu = useScrollMenu(),
      curCateIndex = _useScrollMenu.curCateIndex,
      handleChooseCate = _useScrollMenu.handleChooseCate,
      calculateScrollAnchors = _useScrollMenu.calculateScrollAnchors,
      handleContentScroll = _useScrollMenu.handleContentScroll,
      handleCurCateIndexChange = _useScrollMenu.handleCurCateIndexChange;
    watch(curCateIndex, handleCurCateIndexChange);
    var shopStore = useShopStoreWithOut();
    var menuData = computed(function () {
      return shopStore.getDishesCategory;
    });
    var showCateImg = computed(function () {
      return menuData.value.find(function (item) {
        return item.img;
      });
    });
    var hasInited = ref(false);
    function initMenu() {
      return _initMenu.apply(this, arguments);
    }
    function _initMenu() {
      _initMenu = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _shopStore$getDishesC;
        var shopStore;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              shopStore = useShopStoreWithOut();
              if (!(shopStore.getIsFetchMenuData && ((_shopStore$getDishesC = shopStore.getDishesCategory) === null || _shopStore$getDishesC === void 0 ? void 0 : _shopStore$getDishesC.length) > 0)) {
                _context3.next = 5;
                break;
              }
              hasInited.value = true;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return shopStore.loadMenuData();
            case 7:
              hasInited.value = true;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _initMenu.apply(this, arguments);
    }
    function onDishesListUpdate() {
      return _onDishesListUpdate.apply(this, arguments);
    }
    function _onDishesListUpdate() {
      _onDishesListUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return initMenu();
            case 2:
              if (shopStore.getNeedSwitchShopToast) {
                showToast(t("switchedToShop", [shopStore.getShopName]), 1200);
                shopStore.setNeedSwitchShopToast(false);
              }
              nextTick(function () {
                calculateScrollAnchors();
                handleChooseCate(0);
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _onDishesListUpdate.apply(this, arguments);
    }
    onActivated(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initMenu();
          case 2:
            if (shopStore.getNeedSwitchShopToast) {
              showToast(t("switchedToShop", [shopStore.getShopName]));
              shopStore.setNeedSwitchShopToast(false);
            }
            nextTick(function () {
              calculateScrollAnchors();
              handleChooseCate(0);
            });
            bus.on(onDishesListUpdate);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onDeactivated(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            bus.off(onDishesListUpdate);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    var showDishDetail = ref(false);
    var targetDish = ref(null);
    function handleShowDishDetail(dishItem) {
      if (dishItem.stock_status === DISH_STATUS.IN_STOCK) {
        targetDish.value = dishItem;
        showDishDetail.value = true;
      }
    }
    watch(showDishDetail, function () {
      if (!showDishDetail.value) {
        targetDish.value = null;
      }
    });
    return function (_ctx, _cache) {
      var _component_van_sidebar_item = _resolveComponent("van-sidebar-item");
      var _component_van_sidebar = _resolveComponent("van-sidebar");
      var _component_van_list = _resolveComponent("van-list");
      return hasInited.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sidebar, {
        id: "sidebar-scroll-box",
        "model-value": _unref(curCateIndex),
        class: "sidebar"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.value, function (categoryItem, categoryIndex) {
            return _openBlock(), _createBlock(_component_van_sidebar_item, {
              key: categoryItem.category_id,
              class: _normalizeClass(["sidebar-cate-item", {
                'sidebar-cate-item--img': showCateImg.value
              }]),
              onClick: function onClick($event) {
                return _unref(handleChooseCate)(categoryIndex);
              }
            }, {
              title: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_2, [showCateImg.value ? (_openBlock(), _createBlock(Image, {
                  key: 0,
                  src: categoryItem.img,
                  class: "sidebar-img",
                  "oss-stylename": "type_4",
                  alt: ""
                }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString(categoryItem.name), 1)]), _withDirectives(_createElementVNode("div", _hoisted_4, _cache[1] || (_cache[1] = [_createElementVNode("div", {
                  class: "bottom_right_border"
                }, null, -1)]), 512), [[_vShow, categoryIndex === _unref(curCateIndex) - 1]]), _withDirectives(_createElementVNode("div", _hoisted_5, _cache[2] || (_cache[2] = [_createElementVNode("div", {
                  class: "top_right_border"
                }, null, -1)]), 512), [[_vShow, categoryIndex === _unref(curCateIndex) + 1]])];
              }),
              _: 2
            }, 1032, ["class", "onClick"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["model-value"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_list, {
        id: "content-scroll-box",
        class: "list",
        onScroll: _unref(handleContentScroll)
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.value, function (categoryItem) {
            return _openBlock(), _createElementBlock("div", {
              key: categoryItem.category_id,
              class: "cate-item content-scroll-anchor"
            }, [_createElementVNode("div", _hoisted_8, _toDisplayString(categoryItem.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryItem.dishes_list, function (item) {
              var _targetDish$value;
              return _openBlock(), _createBlock(MenuDish, {
                key: item.id,
                class: "menu-card",
                "dish-item": item,
                active: ((_targetDish$value = targetDish.value) === null || _targetDish$value === void 0 ? void 0 : _targetDish$value.id) === item.id,
                onClick: function onClick($event) {
                  return handleShowDishDetail(item);
                }
              }, null, 8, ["dish-item", "active", "onClick"]);
            }), 128))]);
          }), 128))]), _createVNode(PoweredBy)];
        }),
        _: 1
      }, 8, ["onScroll"])]), _createVNode(DishDetail, {
        show: showDishDetail.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return showDishDetail.value = $event;
        }),
        "target-dish": targetDish.value
      }, null, 8, ["show", "target-dish"])])) : _createCommentVNode("", true);
    };
  }
};